export default "__VITE_ASSET__BWoC2wqt__"